import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

// Send message
export const sendMessage = createAsyncThunk(
  'support/sendMessage',
  async ({ sender, recipient, content, grecaptcha }, { getState, rejectWithValue }) => {
    try {
      const {
        user: { userInfo },
      } = getState();

      const config = {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${userInfo.token}`,
        },
      };

      await axios.post('/api/messages/send', { sender, recipient, content, grecaptcha }, config);
      return true;
    } catch (error) {
      const message =
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message;
      return rejectWithValue(message);
    }
  }
);

// Get messages
export const getMessages = createAsyncThunk(
  'support/getMessages',
  async (user, { getState, rejectWithValue }) => {
    try {
      const {
        user: { userInfo },
      } = getState();

      const config = {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${userInfo.token}`,
        },
      };

      const { data } = await axios.get(`/api/messages/get/${user}`, config);
      return data;
    } catch (error) {
      const message =
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message;
      return rejectWithValue(message);
    }
  }
);

const supportMessageSlice = createSlice({
  name: 'supportMessage',
  initialState: {
    messages: [],
    loading: false,
    error: null,
    success: false,
  },
  reducers: {
    clearSupportMessageState: (state) => {
      state.messages = [];
      state.error = null;
      state.success = false;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(sendMessage.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.success = false;
      })
      .addCase(sendMessage.fulfilled, (state) => {
        state.loading = false;
        state.success = true;
      })
      .addCase(sendMessage.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(getMessages.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getMessages.fulfilled, (state, action) => {
        state.loading = false;
        state.messages = action.payload;
      })
      .addCase(getMessages.rejected, (state, action) => {
        state.loading = false;
        state.messages = [];
        state.error = action.payload;
      });
  },
});

export const { clearSupportMessageState } = supportMessageSlice.actions;
export default supportMessageSlice.reducer;




// import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
// import axios from 'axios';

// // Send message
// export const sendMessage = createAsyncThunk('support/sendMessage', async (messageData, thunkAPI) => {
//   try {
//     const { userLogin: { userInfo } } = thunkAPI.getState();
//     const config = { headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${userInfo.token}` } };
//     const { data } = await axios.post('/api/messages/send', messageData, config);
//     return data;
//   } catch (error) {
//     return thunkAPI.rejectWithValue(error.response?.data?.message || error.message);
//   }
// });

// const supportMessageSlice = createSlice({
//   name: 'supportMessage',
//   initialState: { messages: [], loading: false, error: null },
//   reducers: {},
//   extraReducers: (builder) => {
//     builder
//       .addCase(sendMessage.pending, (state) => { state.loading = true; })
//       .addCase(sendMessage.fulfilled, (state, action) => { state.loading = false; state.messages.push(action.payload); })
//       .addCase(sendMessage.rejected, (state, action) => { state.loading = false; state.error = action.payload; });
//   },
// });

// export default supportMessageSlice.reducer;
